import { isObservabilitySandboxGranted } from "Reducers/observability/sandbox";
import { useAppSelector } from "Store/hooks";

/**
 * Checks if the observability sandbox is reachable
 */
const useObservabilitySandboxAccess = () => {
  const sandboxAccessGranted = useAppSelector(isObservabilitySandboxGranted);

  return sandboxAccessGranted;
};

export default useObservabilitySandboxAccess;
